import axios from 'axios';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addItem } from '../../../store/state/cart';
import { gettoken } from '../../../Localstorage/Store';
import Accountprice from '../../../utils/Accountprice';
import { useDispatch, useSelector } from "react-redux";
import { useDeleteCartMutation } from '../../../store/api/cartapi';

const Table = ({ cartInfo, tableData, count, status,reapplycredit=null }) => {
    const nvg = useNavigate();
    const tokenvalue = gettoken();
    const closeref = useRef(null);
    const openalert = useRef(null);
    const dispatch = useDispatch();
    const [qtymsg, setqtymsg] = useState("");
    const [delitem, setdelitem] = useState(0);
    const [deletecart] = useDeleteCartMutation();
    const [inprocess, setinprocess] = useState(true);
    const gobalvariable = useSelector((state) => state);
    const { bgColor, textColor } = useSelector((state) => state.theam);

    const alertb = () => {
        openalert.current.click();
        setTimeout(() => {
            setqtymsg("");
            closeref.current.click();
        }, 3000);
    };

    const handleBlur = async (e, item, oldvalue) => {
        cartqty(e.target.value, item);
        setinprocess(true);
    };

    const incrementcart = async (qty, id) => {
        cartqty(qty + 1, id);
    };

    const decrementcart = async (qty, id) => {
        status.setshowbtn(false)
        const formdata = new FormData();
        formdata.append("quantity", qty - 1);
        formdata.append("product_id", id);
        const config = {
            headers: {
                Authorization: `Bearer ${tokenvalue.access}`,
            },
        };
        let url = `${process.env.REACT_APP_API_URL}homepageapi/UpdateQuantityOfProduct`;
        const response = await axios.post(url, formdata, config);
        setTimeout(() => { cartInfo.cartRefetch(); }, 400);
        if(reapplycredit != null){
                    reapplycredit();
        }

    };
    const cartqty = async (qty, id) => {
        status.setshowbtn(false)
        try {
            if (qty > 0) {
                const formdata = new FormData();
                formdata.append("quantity", qty);
                formdata.append("product_id", id);
                const config = { headers: { Authorization: `Bearer ${tokenvalue.access}` } };
                let url = `${process.env.REACT_APP_API_URL}homepageapi/UpdateQuantityOfProduct`;
                const response = await axios.post(url, formdata, config);
                if(reapplycredit != null){
                    reapplycredit();
                }
                if (response.data.reason) {
                    setqtymsg(response.data.reason);
                    alertb();
                    setinprocess(true);
                    setTimeout(() => { cartInfo.cartRefetch(); }, 500);
                }
                setTimeout(() => { cartInfo.cartRefetch(); }, 500);
            } else {
                setTimeout(() => { cartInfo.cartRefetch(); }, 500);
            }
        } catch (error) {
            console.log("ddddddddd", error.response);
        }
    };

    const Removeproduct = async (id) => {
        status.setshowbtn(false)
    
        try {
          const cartid = cartInfo.cartData.id;
          const response = await deletecart({ id, cartid });
          if (response.data.obj == "data deleted") {
            dispatch(addItem(gobalvariable.cart - 1));
            setTimeout(() => { cartInfo.cartRefetch(); }, 500);
            if(reapplycredit != null){
                    reapplycredit();
            }

          }
        } catch (error) {
          console.log("error", error);
        }
    };

    return (
        <div
            className="table-responsive scroll-container"
            style={{
                borderRadius: "6px",
                padding: "0px 5px",
                height: "fit-content",
                maxHeight: "65vh",
                background: "white",
            }}
        >
            <h3
                style={{
                    padding: "8px 9px 1px",
                    fontWeight: 700,
                }}
                className="titlesizes"
            >
                Shopping Cart
            </h3>



            <table className="table">
                <thead>
                    <tr>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "15%",
                                textAlign: "center",
                            }}
                        >
                            Image
                        </th>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "12%",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Product Name
                        </th>

                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "16%",
                                textWrap: "nowrap",
                                textAlign: "center",
                            }}
                        >
                            Offer Price
                        </th>

                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "15%",
                                textAlign: "center",
                            }}
                        >
                            Quantity
                        </th>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "22%",
                                textWrap: "nowrap",
                                display: status.client_Discount_Status == false ? "none" : "",
                                textAlign: "center",
                            }}
                        >
                            Client Discount
                        </th>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "18%",
                                textWrap: "nowrap",
                                textAlign: "center",
                            }}
                        >
                            Total Amount
                        </th>

                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "18%",
                                textWrap: "nowrap",
                                textAlign: "center",
                            }}
                        >
                            Taxable Value
                        </th>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "18%",
                                textWrap: "nowrap",
                                textAlign: "center",
                            }}
                        >
                            GST Rate
                        </th>
                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "18%",
                                textWrap: "nowrap",
                                textAlign: "center",
                            }}
                        >
                            GST Amount
                        </th>

                        <th
                            className="family"
                            style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                width: "8%",
                            }}
                        ></th>
                    </tr>
                </thead>
                <tbody>
                    {tableData[0]?.product__title ? (
                        tableData.map((item, index) => (
                            <>
                                <tr>
                                    <td
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <div
                                            onClick={() => {
                                                nvg("/productdetails", {
                                                    state: {
                                                        id: item.product,
                                                        pname: item.product__title,
                                                    },
                                                });
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}media/${item.image[0].original}`}
                                                width="80px"
                                                height="80px"
                                                alt="cart"
                                                className=" "
                                            />
                                        </div>
                                    </td>
                                    <td
                                        className="pnwidth"
                                        style={{ position: "relative", top: "0px" }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "0px",
                                            }}
                                        >
                                            <h6>
                                                <p
                                                    style={{
                                                        color: "black",
                                                        fontSize: "13px",
                                                        lineHeight:
                                                            item.stock == 0 ? "40px" : "63px",
                                                        textAlign: "center",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: "1",
                                                        WebkitBoxOrient: "vertical",
                                                        cursor: "pointer",
                                                        overflow: "hidden",
                                                        position: "relative",
                                                        top: "8px",
                                                    }}
                                                    onClick={() => {
                                                        nvg("/productdetails", {
                                                            state: {
                                                                id: item.product,
                                                                pname: item.product__title,
                                                            },
                                                        });
                                                    }}
                                                >

                                                    {item.product__title}
                                                </p>
                                                <p
                                                    style={{
                                                        color: "red",
                                                        fontSize: "13px",
                                                        textAlign: "center",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: "1",
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        position: "relative",
                                                        top: "0px",
                                                    }}
                                                >
                                                    {" "}
                                                    {item.stock == 0
                                                        ? "(Out of Stock)"
                                                        : ""}
                                                </p>
                                            </h6>
                                        </div>
                                    </td>

                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <h6
                                            className="td-color"
                                            style={{

                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",
                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >


                                            {Accountprice(parseInt(item.price_excl_tax))}


                                        </h6>
                                    </td>
                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "12px 0px",
                                        }}
                                    >
                                        {" "}
                                        <div
                                            className="qty-box"
                                            style={{
                                                padding: "10px 0px",
                                                display: "flex",
                                                justifyContent: "center",
                                                textAlign: "center",
                                                position: "",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "0px",
                                            }}
                                        >
                                            <div
                                                className="input-group qtywidth"
                                                style={{
                                                    border: "0px",
                                                    flexWrap: "nowrap",
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        border: "none",
                                                        outline: "none",
                                                        backgroundColor: "white",
                                                        color: `#${bgColor}`,
                                                        fontSize: "17px",
                                                        fontWeight: 700,
                                                    }}
                                                    onClick={() => {
                                                        decrementcart(
                                                            item.quantity,
                                                            item.product
                                                        );
                                                    }}
                                                >
                                                    -
                                                </button>

                                                <input
                                                    type="number"
                                                    name="quantity"
                                                    style={{
                                                        width: "37px",
                                                        padding: "0.375rem 0.45rem",
                                                        border: "1px solid #dddddd",
                                                    }}
                                                    className="form-control qty input-number"
                                                    defaultValue={item.quantity}
                                                    value={
                                                        inprocess
                                                            ? item.quantity
                                                            : undefined
                                                    }
                                                    onChange={() => {
                                                        setinprocess(false);
                                                    }}
                                                    onKeyDown={(e) => { e.key === "Enter" && handleBlur(e, item.product, item.quantity) }}
                                                    onBlur={(e) => { handleBlur(e, item.product, item.quantity) }}

                                                />
                                                <button
                                                    style={{
                                                        border: "none",
                                                        outline: "none",
                                                        backgroundColor: "white",
                                                        color: `#${bgColor}`,
                                                        fontSize: "17px",
                                                        fontWeight: 700,
                                                    }}
                                                    onClick={() => {
                                                        incrementcart(
                                                            item.quantity,
                                                            item.product
                                                        );
                                                    }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                            display: status.client_Discount_Status == false ? "none" : ''
                                        }}
                                    >
                                        <h6
                                            className="td-color px-lg-0 px-md-2"
                                            style={{
                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",
                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >



                                            {item?.cli_discount ? `${item?.cli_discount}%` : "0%"}


                                        </h6>
                                    </td>
                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <h6
                                            className="td-color px-lg-0 px-md-2"
                                            style={{
                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",
                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >



                                            {Accountprice(parseInt(item.price_excl_tax) * parseInt(item.quantity))}


                                        </h6>
                                    </td>

                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <h6
                                            className="td-color px-lg-0 px-md-2"
                                            style={{
                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",
                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >
                                            {Accountprice(Number.isInteger((item.base_price *
                                                item.quantity
                                            )) ? (
                                                item.base_price *
                                                item.quantity
                                            ) : (
                                                item.base_price *
                                                item.quantity
                                            ).toFixed(2))}



                                        </h6>
                                    </td>
                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <h6
                                            className="td-color px-lg-0 px-md-2"
                                            style={{
                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",
                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >
                                            {item.gst_rate}%

                                        </h6>
                                    </td>
                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <h6
                                            className="td-color px-lg-0 px-md-2"
                                            style={{
                                                fontWeight: 400,
                                                lineHeight: "63px",
                                                fontSize: "13px",

                                                textAlign: "center",
                                                textAlign: "center",
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "8px",
                                            }}
                                        >
                                            {Accountprice((Number.isInteger(item.gst_tax_amount * item.quantity) ? (item.gst_tax_amount * item.quantity) : (item.gst_tax_amount * item.quantity).toFixed(2)))}
                                        </h6>
                                    </td>

                                    <td
                                        style={{
                                            position: "relative",
                                            padding: "0px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                top: "0px",
                                            }}
                                        >

                                            <button
                                                onClick={() => {
                                                    setdelitem(item.product);
                                                }}
                                                type="button"
                                                className="icon"
                                                style={{
                                                    color: "#777777",
                                                    padding: "0px 3px",
                                                    lineHeight: "63px",
                                                    position: "relative",
                                                    top: "8px",
                                                    border: "none",
                                                    backgroundColor: "#fff",
                                                }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModal13400"

                                            >

                                                <img
                                                    src="/images/delete.png"
                                                    style={{ width: "14px" }}
                                                    alt={404}
                                                />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    style={{
                                        display:
                                            tableData.length - 1 == index ? "" : "none",
                                    }}
                                >
                                    <td
                                        colSpan={3}
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        TOTAL
                                    </td>
                                    <td

                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {count.totalqty}
                                    </td>
                                    <td style={{ display: status.client_Discount_Status == false ? "none" : "" }}></td>
                                    <td
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {Accountprice(count.totalmrp.toFixed(0))}
                                    </td>
                                    <td
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {Accountprice(count.taxable_total.toFixed(0))}
                                    </td>
                                    <td
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {Accountprice(count.gst_total.toFixed(0))}
                                    </td>
                                    <td
                                        style={{
                                            textAlign: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    ></td>
                                </tr>
                            </>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="9">
                                <h6
                                    className="td-color"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "34px",
                                        fontSize: "14px",
                                        color: `#${bgColor}`,
                                        textAlign: "center",
                                    }}
                                >
                                    Your Cart is Empty!
                                </h6>
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <button
                                        className="btn"
                                        onClick={() => {
                                            nvg("/home");
                                        }}
                                        style={{
                                            backgroundColor: `#${bgColor}`,
                                            color: "#fff",
                                            borderRadius: "0px",
                                            fontSize: "13px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Shop Now
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>




































            {/* pop box start here  */}


            <div style={{
                overflow: "hidden",
                width: "5%",
                position: "relative",
            }}
            >
                <button
                    ref={openalert}
                    type="button"
                    style={{
                        fontSize: "12px",
                        position: "absolute",
                        left: "400px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal140000340"
                    class="dropdown-item"
                >
                </button>
            </div>

            <div
                className="modal fade"
                id="exampleModal140000340"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                    }}
                >
                    <div className="modal-content centercontentofalert" style={{ backgroundColor: `#${bgColor}` }}>
                        <div className="modal-header mod-line d-none"></div>
                        <div className="modal-body" style={{ padding: "0px" }}>
                            <div className="row">
                                <p
                                    className="ccedit-p "
                                    style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        backgroundColor: `#${bgColor}`,
                                        color: "white",
                                        fontWeight: "550",
                                    }}
                                >
                                    {qtymsg}
                                </p>
                            </div>
                        </div>
                        <div
                            className="modal-footer mod-line m-auto"
                            style={{
                                border: "none",
                                position: "absolute",
                                left: "389px",
                            }}
                        >
                            {/* <button type="button" className="btn closecancel" data-bs-dismiss="modal"
                aria-label="Close">Cancel</button> */}
                            <button
                                type="button"
                                className="btn closebtn "
                                style={{
                                    paddingRight: "20px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#230BB3",
                                }}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                ref={closeref}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>


             {/* delete item  */}
             <div
            className="modal fade"
            id="exampleModal13400"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered ">
              <div className="modal-content">
                <div className="modal-header mod-line d-none"></div>
                <div className="modal-body">
                  <div className="row gy-3 mt-2">
                    <h4
                      style={{
                        color: `#${bgColor}`,
                        cursor: "pointer",
                        textAlign: "center",
                        fontSize: "21px",
                        fontWeight: "800",
                      }}
                    >
                      Cart Alert
                    </h4>
                    <p
                      className="ccedit-p "
                      style={{ textAlign: "center", fontSize: "13px" }}
                    >
                      Are you sure you want to remove this Item ?
                    </p>
                  </div>
                </div>
                <div
                  className="modal-footer mod-line m-auto"
                  style={{ border: "none" }}
                >
                  <button
                    type="button"
                    className="btn closebtn "
                    style={{
                      paddingRight: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: `#${bgColor}`,

                    }}
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn closebtn profile-edit-btn justhoverwh"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      Removeproduct(delitem);
                    }}
                    style={{
                      backgroundColor: `#${bgColor}`,
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
             </div>
             
            {/* pop box end here  */}


        </div>
    )
}

export default Table